import { getApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  closeBottomSheet,
  getIframe,
  setAddChangeEventListener,
  setAddEventListener,
  setBottomSheet,
  stringToHTML,
} from '../../helpers';
import { amtFormatter } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const ChargDetails = {
  search: {
    trDiv: '',
    from: '',
    to: '',
  },
  listData: [],
  trDtlDivList: [],

  initialFrom: '',
  initialTo: '',

  render: async () => {
    //initialize
    const date = new Date();

    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    ChargDetails.initialFrom = `${year}-${month}-01`;
    ChargDetails.initialTo = `${year}-${month}-${day}`;

    ChargDetails.search.from = ChargDetails.initialFrom;
    ChargDetails.search.to = ChargDetails.initialTo;

    return `
        <div>
          <a id="connect_pay_back_button" class="c_back"></a>
        </div>
            <div class="c_title1">충전머니 내역조회</div>
        <div class="form-group m_b_20"> 
            <div class="c_bod1 c_box skin1_bod" id="charg_status">
                <div class="c_label4_3" id="charg_keyword_label">전체</div>
                <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
                
            </div>
        </div>
        <div class="form-group m_b_20">
            <div class="c_bod1 c_box skin1_bod" id="date_status">
                <input class="skin1_bod c_label6_3" type="date" id="charge_search_from" value="${ChargDetails.initialFrom}"/>
                <input class="skin1_bod c_label6_3" type="date" id="charge_search_to" value="${ChargDetails.initialTo}"/>
            </div>
        </div>
        <div class="p_lr_10">
            <table class="c_table1" id="charg_list_table" />
        </div>
    `;
  },

  afterRender: async () => {
    let preFromDate;
    let preToDate;

    // setAlertModal
    setAlertModal();

    try {
      const codeRes = await getApv('common/code?grpCode=TR_DTL_DIV');
      if (codeRes == null) {
        throw '데이터 로드 중입니다.\n잠시 후 시도해 보세요 (1001)';
      }
      ChargDetails.trDtlDivList = codeRes.filter(
        (item) => item.codeId > 3000 && item.codeId < 4000
      );
      ChargDetails.trDtlDivList.unshift({ codeId: '', codeName: '전체' });
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e);
      console.error(e.resultMessage);
      return;
    }

    const modalLayer = `
    <div class="modal c_btm1" id="charg_status_content">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">구분</h5>
                    <button type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="search_keyword_list" />
            </div>
        </div>
    </div>
    `;
    // Functions
    const getTrDivName = (trDiv) => {
      for (const index in ChargDetails.trDtlDivList) {
        if (trDiv === ChargDetails.trDtlDivList[index].codeId) {
          return ChargDetails.trDtlDivList[index].codeName;
        }
      }
      return trDiv;
    };

    const searchChargeDetails = () => {
      getIframe().getElementById('charg_list_table').innerHTML = '';

      const fromTrDt = ChargDetails.search.from;
      const toTrDt = ChargDetails.search.to;
      const trDiv = ChargDetails.search.trDiv;

      getApv(
        'charging/chargeTransList?trDiv=' +
          trDiv +
          '&fromTrDt=' +
          fromTrDt +
          '&toTrDt=' +
          toTrDt
      )
        .then((res) => {
          ChargDetails.listData = res.chrgTransList;
          for (const item of ChargDetails.listData) {
            const subTrUniqNo = item.trUniqno.substring(
              10,
              item.trUniqno.length
            );

            getIframe().getElementById(
              'charg_list_table'
            ).innerHTML += `<tr style="cursor: pointer">
                    <th class="p_b_20" >
                        <div class="c_label4_1">${getTrDivName(
                          item.trDiv
                        )}</div>
                        <div class="c_label5_2">${subTrUniqNo}</div>
                        
                    </th>
                    <td class="p_b_20">
                        <div class="c_label4_2">${
                          item.inAmt !== 0
                            ? amtFormatter(item.inAmt)
                            : '- ' + amtFormatter(item.outAmt)
                        }</div>
                        <div class="c_label5_2">${
                          item.trDt + ' ' + item.trTm
                        }</div>
                    </td>
                </tr>`;
          }
        })
        .catch((err) => {
          showAlertModal('오류', err.resultMessage);
          console.error(err);
        });
    };
    const onClickKeyword = (item) => {
      getIframe().getElementById('charg_keyword_label').innerText =
        item.innerText;
      ChargDetails.search.trDiv = item.getAttribute('value');
      getIframe()
        .querySelectorAll('#search_keyword_list > div')
        .forEach((element) => {
          element.className =
            element.id === ChargDetails.search.trDiv
              ? 'item c_label6'
              : 'item c_label6_1';
        });
      searchChargeDetails();
      closeBottomSheet('charg_status');
    };

    //View Draw Functions
    const drawLimitBottomSheet = () => {
      stringToHTML(modalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
      ChargDetails.trDtlDivList.forEach((item) => {
        if (ChargDetails.search === item.codeId) {
          getIframe().getElementById('charg_keyword_label').innerText =
            item.codeName;
          ChargDetails.search.trDiv = item.codeId;
        }
        getIframe().getElementById(
          'search_keyword_list'
        ).innerHTML += `<div class="${
          item.codeId === ChargDetails.search.trDiv
            ? 'item c_label6'
            : 'item c_label6_1'
        }"
                                    value="${item.codeId}"
                                    id="${item.codeId}">${item.codeName}</div>`;
      });

      setBottomSheet('charg_status');
    };

    //View Draw
    drawLimitBottomSheet();

    // SetEvents
    setAddEventListener('connect_pay_back_button', () => history.back());
    setAddEventListener('charge_search_from', (e) => {
      preFromDate = e.target.value;
    });
    setAddEventListener('charge_search_to', (e) => {
      preToDate = e.target.value;
    });
    setAddChangeEventListener('charge_search_from', async (e) => {
      const fromDate = e.target.value;
      const toDate = getIframe().getElementById('charge_search_to').value;
      if (fromDate > toDate || fromDate > ChargDetails.initialTo) {
        fromDate > ChargDetails.initialTo
          ? showAlertModal('확인', '오늘일자 이후는 선택할 수 없습니다.')
          : showAlertModal('확인', '종료일자 이후는 선택할 수 없습니다.');
        getIframe().getElementById('charge_search_from').value = preFromDate;
        return;
      }
      ChargDetails.search.from = fromDate;
      await searchChargeDetails();
    });
    setAddChangeEventListener('charge_search_to', async (e) => {
      const fromDate = getIframe().getElementById('charge_search_from').value;
      const toDate = e.target.value;
      if (fromDate > toDate) {
        showAlertModal('확인', '시작일자 이전은 선택할 수 없습니다.');
        getIframe().getElementById('charge_search_to').value = preToDate;
        return;
      }
      ChargDetails.search.to = toDate;
      await searchChargeDetails();
    });
    getIframe()
      .querySelectorAll('#search_keyword_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          onClickKeyword(element);
        });
      });

    searchChargeDetails();
  },
};
export default ChargDetails;
